import BasicToastAlert from "../plugins/glyph-alerts/admin/toasts/basic-toast-alert.js";
import ToastrAlert from "../plugins/glyph-alerts/admin/toasts/toastr-alert.js";
import AlertInterface from "../plugins/glyph-alerts/alert-interface.js";
import NotyfAlert from "../plugins/glyph-alerts/admin/toasts/notyf-alert.js";

export function MM_jumpMenu(targ, selObj, restore) { //v3.0
    const newLocation = selObj.options[selObj.selectedIndex].value;

    if (targ === "parent") {
        window.parent.location = newLocation;
    } else if (targ === "self") {
        window.location = newLocation;
    } else {
        console.error("Invalid target: " + targ);
    }

    if (restore) {
        selObj.selectedIndex = 0; // Reset the selection if restore is true
    }
}

export function makeseo(element, title, lang_id=1, menu_page=0) {
    $.post(APPLICATION + "/service/allgroups/makeseo?element=" + element, {title: $("input[name=" + title + "]").val(), menu_page: menu_page, lang_id: lang_id}, null, "script");
}

$(document).ready(function () {
    /*SELECT2 POSTAVKE*/
    initializeSelect2();


    $('.MM_jumpMenu').on('change', function () {
        MM_jumpMenu('parent', this, false);
    })

    $("#modal_continue").click(function (e) {
        $(this).parents(".modal").modal("hide");
    });

    $(document).on('click', ".btn_provjera_safe", function (e) {
        e.preventDefault();
        $("#modal_continue").attr("onclick", $(this).data("onclick"));
        $("#modal_continue").attr("href", $(this).data("href"));
        $("#deleteModal").modal("show");
    });

    $(".btn_provjera_reason").click(function (e) {
        e.preventDefault();
        $("#frmReasonContinue").attr("action", $(this).data("href"));
        $('#reasonModal').modal({show: true});
    });

    $("#clear_cache").click(function (e) {
        e.preventDefault();
        var $this = $(this);
        $this.addClass("rotate");
        $.ajax({
            method: 'post',
            url: $(this).attr("href")
        }).done(function (data) {
            showAlert(ALERT_TYPE, data);
        }).fail(function () {
            console.error("Clearing cache in Next App failed!");
        }).always(function () {
            setTimeout(function () {
                $this.removeClass("rotate");
            }, 200);
        });
    });

    /*Copy to clipboard functionality*/
    // $('.copy-to-clipboard').on('click', function (e) {
    //     e.preventDefault();
    //     var $this = $(this);
    //     var $id = $this.data('full-length');
    //     var title = $this.data('bs-title');
    //     var titleSuccess = $this.data('title-copied');
    //
    //     var tooltip = bootstrap.Tooltip.getInstance($this[0]);
    //     if (!tooltip) {
    //         tooltip = new bootstrap.Tooltip($this[0]);
    //     } else {
    //         tooltip.hide();
    //     }
    //     // Copy text to clipboard
    //     navigator.clipboard.writeText($id).then(function () {
    //         $this.attr('data-bs-title', titleSuccess);
    //         $this.attr('data-bs-custom-class', 'tooltip-success');
    //         tooltip = new bootstrap.Tooltip($this[0]);
    //         tooltip.show();
    //         setTimeout(function () {
    //             tooltip.hide();
    //             $this.attr('data-bs-title', title);
    //             $this.removeAttr('data-bs-custom-class');
    //             new bootstrap.Tooltip($this[0]);
    //         }, 500);
    //     }).catch(function (error) {
    //         console.error('Error copying text: ', error);
    //     });
    // });

    maxlengthInit();

    /*VALIDATION*/
    $("form.validate").each(function (e) {
        validateForms($(this));
    })
    $("#modal_two_factor_authentication form").each(function (e) {
        validateForms($(this))
    })

// Trigger event
    $(".iframePreview").on("click", function (e) {
        e.preventDefault();

        // Get the href attribute as the iframe source
        let src = $(this).attr("href");
        if (!src) return;

        // Append 'iframe=1' to the URL
        src += src.includes("?") ? "&iframe=1" : "?iframe=1";

        // Calculate dimensions dynamically
        const width = Math.max(window.outerWidth * 0.9, 300); // Minimum width: 300px
        const height = Math.max(window.outerHeight - 120, 200); // Minimum height: 200px

        // Select the modal and customize its dimensions
        const iframeModal = $("#iframeModal");
        iframeModal.find(".modal-dialog").css({
            "width": `${width}px`,
            "height": `${height}px`,
            "max-width": "90%", // Optional: Responsive adjustments
            "max-height": "95%"
        });
        iframeModal.find("iframe").css({
            "width": "100%", // Make iframe responsive
            "height": `${height}px`
        }).attr("src", src);

        // Update additional elements and display the modal
        iframeModal.find("a.page_src").attr("href", src);
        iframeModal.modal("show");
    });


    /* INITIALIZE SUBMIT BUTTON IN TOOLBAR */
    initializeToolbarSubmitButton()

    /*CARD TOGGLE*/
    $(".js-card-toggle").on("click", function (e) {
        e.preventDefault();
        var cardBody = $(this).closest(".card").find(".card-body");
        var icon = $(this).find("i");
        if (cardBody.length > 0) {
            cardBody.slideToggle(300, function () {
                if (cardBody.is(":visible")) {
                    icon.removeClass("bi-arrows-angle-expand").addClass("bi-arrows-angle-contract");
                } else {
                    icon.removeClass("bi-arrows-angle-contract").addClass("bi-arrows-angle-expand");
                }
            });
        }
    })

    //Check functions on click Ajax
    $(".js-ajax-link").click(function (e) {
        e.preventDefault();
        $.ajax({
            url: $(this).attr("href")
        }).done(function (data) {
            showAlert(ALERT_TYPE, data);
        }).fail(function (error) {
            console.error(error);
        });
    });

    if($(".toolbar").length > 0) {
        updateBodyScrollClass();
        $(window).on('resize', updateBodyScrollClass);
    }


    //FILTER CLEAR BUTTON
    const clearButton = $('#clear-filters');
    const form = clearButton.closest('.card').find('form');
    var $fields = form.find('input[type="text"], select');

    // Show/hide based on whether any field has a value
    function toggleClearBtn() {
        var anyFilled = false;
        $fields.each(function() {
            var v = $(this).val();
            if (v !== null && v.toString().trim() !== '') {
                anyFilled = true;
                return false; // break
            }
        });
        clearButton.toggle(anyFilled);
    }

    // On load
    toggleClearBtn();

    // On user change
    $fields.on('input change', toggleClearBtn);
});

function hasVerticalScrollbar() {
    return $("body").height() >= $(window).height();
}

window.updateBodyScrollClass = function updateBodyScrollClass() {
    const $body = $('body');
    $body.toggleClass('with-scroll', hasVerticalScrollbar());
}

window.maxlengthInit = function maxlengthInit() {
    $('input[maxlength]:not(.js-code-input)').maxlength({
        warningClass: "badge bg-warning",
        limitReachedClass: "badge bg-danger",
        alwaysShow: true
    });
    $("textarea[maxlength]").maxlength({
        warningClass: "badge bg-warning",
        limitReachedClass: "badge bg-danger",
        alwaysShow: true,
        validate: true
    });
}

window.initializeSelect2 = function initializeSelect2() {
    try {
        $('select:not(.not-select2):not(.flatpickr-monthDropdown-months)').each(function () {
            var selectElement = $(this);
            var dropdownClass = '';

            if (selectElement.hasClass('form-select-sm')) {
                dropdownClass = 'select2-dropdown-sm';
            } else if (selectElement.hasClass('form-select-lg')) {
                dropdownClass = 'select2-dropdown-lg';
            } else {
                dropdownClass = '';
            }

            if (selectElement.hasClass('has-search')) {
                selectElement.select2({
                    placeholder: selectElement.data('placeholder'),
                    dropdownCssClass: dropdownClass
                }).on('select2:open', function () {
                    $('.select2-search__field').attr('placeholder', 'Search...');
                }).on('select2:select', function (e) {
                    revalidateSelect($(this));
                    checkReactSelect2(selectElement);
                });
            } else {
                selectElement.select2({
                    placeholder: selectElement.data('placeholder'),
                    minimumResultsForSearch: Infinity,
                    dropdownCssClass: dropdownClass
                }).on('select2:select', function (e) {
                    revalidateSelect($(this));
                    checkReactSelect2(selectElement);
                });
            }
        });
    } catch (e) {
        console.error('error: ', e.message)
    }
}

function checkReactSelect2(selectElement) {
    if(selectElement.hasClass('react-select2')) {
        selectElement[0].dispatchEvent(new Event('change', {bubbles: true}));
    }
}

/* SHOW SELECTED PAGE IN SIDEBAR */
window.showActiveMenuItem = function showActiveMenuItem(item, child = null) {
    var activeMenuItem = $(`.sidebar-item[data-rel*=${item}]`);
    activeMenuItem.addClass("active opened");
    activeMenuItem.find(">ul").show();

    if (child) {
        var childMenuItem = activeMenuItem.find(`li[data-rel=${child}]`);
        childMenuItem.addClass("hover");
    }

    // Auto-highlight active menu based on URL
    var url = window.location.href;
    var i = url.indexOf("?") > 0 ? url.indexOf("?") : 0;
    var dataHref = i > 0 ? url.slice(i) : "";

    // Mark current page as active
    $(`a[href='${dataHref}']`).addClass("active");

    // If child is defined, highlight it
    if (child) {
        activeMenuItem.find(`a[href='${child}']`).addClass("active");
    }
};

/* SUBMIT BUTTON IN TOOLBAR */
window.initializeToolbarSubmitButton = function initializeToolbarSubmitButton() {
    const toolbar = $(".content main .toolbar");
    const buttonPlaceholder = toolbar.find(".button-placeholder");
    const content = $(".content main");

    if (buttonPlaceholder.length === 0) return;

    const button = content.find(".card").find('button[type="submit"]:not(.js-skip-toolbar-button)').eq(0);
    button.removeClass("d-none");

    if (button.length) {
        buttonPlaceholder.html(button);
        content.find('.card button[type="submit"]:not(.js-skip-toolbar-button)').addClass("d-none");
    }

    toolbar.on("click", 'button[type="submit"]', function () {
        const formSelector = $(this).data("form") || "form";
        const $form = content.find(formSelector);

        if ($form.length) {
            if ($form.valid()) {
                $form.submit();
            } else {
                $form.validate().focusInvalid();
            }
        }
    });
}

/*THEME TOGGLE*/
const dropdownItems = document.querySelectorAll('.theme-dropdown .dropdown-item');
const root = document.documentElement;

function updateActiveTheme(theme) {
    dropdownItems.forEach(button => {
        button.classList.toggle('active', button.getAttribute('data-theme') === theme);
    });
}

function setTheme(theme) {
    if (theme === 'system') {
        const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
        root.setAttribute('data-bs-theme', prefersDark ? 'dark' : 'light');
        localStorage.setItem('theme', 'system');
    } else {
        root.setAttribute('data-bs-theme', theme);
        localStorage.setItem('theme', theme);
    }
    updateActiveTheme(theme)
}

dropdownItems.forEach((item) => {
    item.addEventListener('click', (e) => {
        const theme = e.target.getAttribute('data-theme');
        setTheme(theme);
    });
});
window.addEventListener('DOMContentLoaded', () => {
    const savedTheme = localStorage.getItem('theme') || 'light';
    setTheme(savedTheme);
});
const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
mediaQuery.addEventListener('change', () => {
    if (localStorage.getItem('theme') === 'system') {
        setTheme('system');
    }
});

window.copyToClipboard = function copyToClipboard(message) {
    try {
        navigator.clipboard.writeText(message);
    } catch (e) {
        console.log(e);
    }
}

window.showAlert = function showAlert(alertType, data) {
    try {
        switch (alertType) {
            case 'toastr':
                var alertNotification = new ToastrAlert(data);
                break;
            case 'notyf':
                var alertNotification = new NotyfAlert(data);
                break;
            case 'basic_toast':
                var alertNotification = new BasicToastAlert(data);
                break;
        }

        if (!(alertNotification instanceof AlertInterface)) throw new Error("toastNotification must be instance of ToastNotification");
        alertNotification.show();
    } catch (error) {
        console.error(error);
    }
}

/*VALIDATION*/
function passwordStrengthValidator(value, element) {
    if (this.optional(element)) return true;
    if (value.length < 8) return false;
    const strengthRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
    return strengthRegex.test(value);
}

function passwordStrengthMessage(params, element) {
    if ($(element).val().length < 8) {
        return lang['validatePasswordTooShort'] || "Password must be at least 8 characters long.";
    }
    return lang['validatePasswordStrength'] || "Password must contain uppercase, lowercase, digit and special character.";
}

window.validateForms = async function validateForms(form) {
    if (typeof form.attr("novalidate") !== "undefined") return;

    const { loadJQueryValidate } = await import('./jquery-validate-loader.js');
    const validator = await loadJQueryValidate();

    if (!validator) {
        console.error("Failed to load jQuery Validate.");
        return;
    }

    // Add method once loaded
    jQuery.validator.addMethod("strongPassword", passwordStrengthValidator, passwordStrengthMessage);

    jQuery.extend(jQuery.validator.messages, {
        required: "required",
        email: "invalid email"
    });

    const validationOptions = {
        errorPlacement: function (error, element) {
            if (element.is(':radio') || element.is(':checkbox')) {
                error.appendTo(element.closest('div'));
                element.parent().addClass("is-invalid");
            } else {
                error.insertAfter(element);
            }
        },
        submitHandler: function (element) {
            var elem = $(element);
            var callback = elem.data("callback");
            if (typeof window[callback] === "function") {
                window[callback](elem);
            } else {
                element.submit();
            }
        }
    };

    if (form.attr('id') === 'frmEditUser') {
        validationOptions.rules = {
            password: {
                strongPassword: {
                    depends: function (element) {
                        return $(element).val().trim().length > 0;
                    }
                },
                required: false
            },
            password_confirm: {
                equalTo: {
                    param: '[name="password"]',
                    depends: function () {
                        return $('[name="password"]').val().trim().length > 0;
                    }
                },
                required: false
            }
        };
    }

    form.validate(validationOptions);
};


function revalidateSelect(select) {
    var $label = select.siblings("label.error");

    select.removeClass('error');
    $label.remove();
    const $form = select.closest('form');

    if ($form.length && typeof $form.validate === 'function') {
        $form.validate().element(select[0]);
    }
}

window.getCssVariableValue = function getCssVariableValue(variableName) {
    var hex = getComputedStyle(document.documentElement).getPropertyValue(variableName);
    if (hex && hex.length > 0) {
        hex = hex.trim();
    }

    return hex;
}


$.elatus_spinner = function (containerSelector, callback) {
    if (callback == "hide") {
        $(containerSelector).find('.loader').fadeOut();
        return;
    }

    if ($(containerSelector).find('.loader').length == 0) {
        var spinnerWrapper = $("<div/>", {class: "loader"})
        var inner = $("<div/>", {class: "loader-wrap"});
        var spinner = $("<span/>");
        spinner.appendTo(inner);
        inner.appendTo(spinnerWrapper);
        spinnerWrapper.appendTo($(containerSelector));
    }

    $(containerSelector).find('.loader').fadeIn(400, callback);
};


function showOverlay() {
    $('.loader').css('display', 'block');
}

function hideOverlay() {
    $('.loader').css('display', 'none');
}

window.setupLandingAutocomplete = function setupLandingAutocomplete(inputSelector, labelSelector, autocompleteUrl, postUrl){
    if($(inputSelector).length === 0){
        return;
    }

    var inputButton = $(inputSelector).siblings("button");

    inputButton.on("click", function () {
        var id = $(this).data("id") || 0;
        var listUrl = $(this).data("list-url") || "";
        var editUrl = $(this).data("edit-url") || "";
        console.log("BUTTON CLICK", id, listUrl, editUrl);

        if(id > 0) {
            window.open(editUrl.replace("{ID}", id));
        } else  {
            window.open(listUrl);
        }
    });

    const acKey = "__acInstance_" + String(inputSelector).replace(/[^\w$]/g, "_");
    window[acKey] = new AutoComplete();
    window[acKey].add(inputSelector, autocompleteUrl, {
        onSelect: (event, details) => {
            const selectedItem = details.selection.value;

            $(labelSelector).html(": " + selectedItem.item);

            $(inputSelector).val(selectedItem.item);

            if (selectedItem.id != null) {
                inputButton.data('id', selectedItem.id);
            }

            if (postUrl && selectedItem.id != null) {
                $.post(
                    postUrl + selectedItem.id + "&p=" + (selectedItem.portal ?? ""),
                    null,
                    null,
                    "script"
                );
            }
        },
    });
}
